import { render } from "./MoreActionsButton.vue?vue&type=template&id=e5d701b2"
import script from "./MoreActionsButton.vue?vue&type=script&lang=js"
export * from "./MoreActionsButton.vue?vue&type=script&lang=js"
script.render = render

export default script